export const nationaalGeoRegisterCSWUrl = 'https://nationaalgeoregister.nl/geonetwork/srv/dut/csw?SERVICE=CSW&REQUEST=GetRecords&version=2.0.2';

export function createOcwQuery(serviceUrl, subjectValue, typeValue, maxRecords, startPosition) {
    // If only 1 filter we do not need and And.
    let andOpen = '';
    let andClose = '';
    // if more than 1 filter is needed we must put them together using And.
    const isMoreThanOneNotNull = [serviceUrl, subjectValue, typeValue].filter(val => val !== null && val !== '').length > 1;
    if (isMoreThanOneNotNull) {
        andOpen = '<ogc:And>';
        andClose = '</ogc:And>';
    }
    let filter = `${wildCardFilter(serviceUrl)}${equalFilter('subject', subjectValue)}${equalFilter('type', typeValue)}`;

    return `<?xml version="1.0" encoding="UTF-8"?>
            <csw:GetRecords xmlns:csw="http://www.opengis.net/cat/csw/2.0.2" service="CSW" version="2.0.2" resultType="results" 
            maxRecords="${maxRecords}" startPosition="${startPosition}" xmlns:gmd="http://www.isotc211.org/2005/gmd">
                <csw:Query typeNames="csw:Record">
                    <csw:ElementSetName>full</csw:ElementSetName>
                    <csw:Constraint version="1.1.0">
                        <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                            ${andOpen}
                            ${filter}
                            ${andClose}
                        </ogc:Filter>
                    </csw:Constraint>
                </csw:Query>
            </csw:GetRecords>`;
};

function wildCardFilter(filterValue) {
    if (filterValue) {
        return `<ogc:PropertyIsLike wildCard="%" singleChar="_" escapeChar="\\">
                   <ogc:PropertyName>csw:AnyText</ogc:PropertyName>
                   <ogc:Literal>%%${filterValue}%%</ogc:Literal>
                </ogc:PropertyIsLike>`;
    } else {
        return '';
    }
}

function equalFilter(propertyName, filterValue) {
    if (filterValue) {
        return `<ogc:PropertyIsEqualTo>
                   <ogc:PropertyName>${propertyName}</ogc:PropertyName>
                   <ogc:Literal>${filterValue}</ogc:Literal>
                </ogc:PropertyIsEqualTo >`;
    } else {
        return '';
    }
}


